export function goTo(url) {
    return window.location.href = url;
}